<template>
  <span
    class="inline-flex shrink-0 select-none items-center justify-center overflow-hidden rounded-full border border-white/20 bg-gray-700/85 text-gray-200 shadow-[0_0_0_2px_rgba(7,10,15,0.9)]"
    :class="[sizeClasses.container, textClass]">
    <img v-if="showsImage" :src="src" :alt="altText" class="h-full w-full rounded-full object-cover" @error="onImageError">
    <span v-else class="font-medium uppercase">{{ initials }}</span>
  </span>
</template>

<script>
const SIZE_MAP = {
  xs: {
    container: 'h-6 w-6',
    text: 'text-[10px]',
  },
  sm: {
    container: 'h-8 w-8',
    text: 'text-xs',
  },
  md: {
    container: 'h-9 w-9',
    text: 'text-xs',
  },
  lg: {
    container: 'h-11 w-11',
    text: 'text-sm',
  },
  xl: {
    container: 'h-12 w-12',
    text: 'text-sm',
  },
}

export default {
  name: 'Avatar',
  props: {
    src: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'md',
    },
    alt: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      hasImageError: false,
    }
  },
  computed: {
    normalizedSize() {
      return Object.prototype.hasOwnProperty.call(SIZE_MAP, this.size) ? this.size : 'md'
    },
    sizeClasses() {
      return SIZE_MAP[this.normalizedSize]
    },
    textClass() {
      return this.sizeClasses.text
    },
    showsImage() {
      return Boolean(this.src) && !this.hasImageError
    },
    initials() {
      const normalizedName = String(this.name ?? '').trim()
      if (normalizedName === '') {
        return '??'
      }

      const nameParts = normalizedName
        .split(/\s+/)
        .map((part) => part.trim())
        .filter((part) => part.length > 0)

      if (nameParts.length === 1) {
        return nameParts[0].slice(0, 2).toUpperCase()
      }

      return `${nameParts[0][0]}${nameParts[1][0]}`.toUpperCase()
    },
    altText() {
      if (this.alt !== '') {
        return this.alt
      }

      const normalizedName = String(this.name ?? '').trim()
      return normalizedName === '' ? 'User avatar' : `${normalizedName} avatar`
    },
  },
  watch: {
    src() {
      this.hasImageError = false
    },
  },
  methods: {
    onImageError() {
      this.hasImageError = true
    },
  },
}
</script>
